import React from "react";
import spaceint2 from "../../utils/spaceint2";

const Tests = ({ tests }) => {
  if (!tests) {
    return "Тесты: -";
  }

  return (
    <span>
      Тесты: {spaceint2(tests.tests_cnt)} ({spaceint2(tests.campaigns_cnt)})
    </span>
  );
};

export default Tests;
